import { render, staticRenderFns } from "./we-banner.vue?vue&type=template&id=6cb772a2&"
import script from "./we-banner.vue?vue&type=script&lang=js&"
export * from "./we-banner.vue?vue&type=script&lang=js&"
import style0 from "./we-banner.vue?vue&type=style&index=0&id=6cb772a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports